export const LIST_SERVICE_TAG = {
  LIST: "LIST",
};
